module.exports = __webpack_public_path__ + "img/layers.d32d018b.svg";